import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/useAuth";
import NavbarComp from "../components/NavBar";

type Props = { children: React.ReactNode };

const PrivateRoute = ({ children }: Props) => {
    const loc = useLocation();
    const { isLoggedIn } = useAuth();
    return isLoggedIn() ? (
        <>
            <NavbarComp />
            {children}
        </>
    ) : (
        <Navigate to="/login" state={{ from: loc }} replace />
    );
};

export default PrivateRoute;
